import React from 'react'
import {Footer} from 'react-materialize'

const AppFooter = () => {
  return(
    <Footer
      className="grey darken-3"
      copyrights="&copy; 2019 Erick Perez Design"
      moreLinks={<a className="grey-text text-lighten-4 right" href="http://erickperezdesign.com/">My Site</a>}
      links={<div>
        <h5 className="white-text">Links</h5>
        <ul>
          <li><a className="grey-text text-lighten-3" href="https://reactjs.org/">React</a></li>
          <li><a className="grey-text text-lighten-3" href="https://materializecss.com">Materialize</a></li>
          <li><a className="grey-text text-lighten-3" href="http://erickperezdesign.com/">My Site</a></li>
        </ul>
      </div>}
    >
    <h5 className="white-text">
      Footer Content
    </h5>
    <p className="grey-text text-lighten-4">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Interdum et malesuada fames ac ante ipsum primis in faucibus. Nam libero nibh, efficitur id lectus sed, pulvinar suscipit odio. Curabitur posuere urna et porttitor sollicitudin. Suspendisse in nibh a magna sollicitudin bibendum sit amet at enim. Mauris pharetra, sapien eget commodo congue, risus lorem fringilla libero, eget sodales metus eros et diam. Donec laoreet nulla vitae purus ultrices, nec vehicula lacus gravida.  
    </p>
  </Footer>
    )
}

export default AppFooter